import { Card } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React from 'react'
import { CARD_DEFAULTS } from 'styles/styles'
import { theme } from 'theme/theme'

const useClasses = makeStyles({
  card: {
    ...CARD_DEFAULTS,
    display: 'flex',
    flexDirection: 'column',
  },

  container: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    flexGrow: 1,
  },

  imgContainer: {
    alignSelf: 'center',
    padding: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    width: 260,
  },
  img: {
    margin: theme.spacing(),
    maxWidth: 260,
  },
  cardContent: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
})

interface ImageCardProps {
  imgUrl: string
  children?: React.ReactNode
}

const useImgCardContentClasses = makeStyles({
  imgCardContent: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    flexGrow: 1,
    flexDirection: 'column',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(),
    },
  },
})

export const ImageCardContent: React.FC<{
  children?: React.ReactNode
}> = props => {
  const { imgCardContent } = useImgCardContentClasses()
  return <div className={imgCardContent}>{props.children}</div>
}

const useImgCardActionsClasses = makeStyles({
  imgCardActions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(),
    },
    gap: theme.spacing(2),
  },
})

export const ImageCardActions: React.FC<{
  children?: React.ReactNode
}> = props => {
  const { imgCardActions } = useImgCardActionsClasses()
  return <div className={imgCardActions}>{props.children}</div>
}

export const ImageCard: React.FC<ImageCardProps> = props => {
  const classes = useClasses()
  const { imgUrl, children } = props

  return (
    <Card className={classes.card} elevation={1}>
      <div className={classes.container}>
        <div className={classes.imgContainer}>
          <img
            className={classes.img}
            src={imgUrl}
            aria-hidden={true}
            alt='img'
          />
        </div>
        <div className={classes.cardContent}>{children}</div>
      </div>
    </Card>
  )
}
